<template>
    <div class="inner wz-list-toc__con">
        <strong>CONTENTS</strong>
        <div class="side_block" style="display: flex; flex-direction: column; flex: 1 1 0%;">
            <div class="category"
                    :class="webzine_category_code === 'all' ? 'selected-category' : ''">
                <h3 @click="selectCategory('all')" class="category-title">전체</h3>
            </div>
            <div class="category" v-for="category in categoryList" :key="category.webzine_category_code">
                <div :class="webzine_category_code === category.webzine_category_code ? 'selected-category' : ''">
                    <h3 class="category-title" @click="selectCategory(category.webzine_category_code)">{{
                            category.webzine_category_name
                    }}</h3>
                </div>
            </div>
            <div style="padding-top: 30px; display: flex;">
                <el-input placeholder="검색어를 입력하세요" prefix-icon="el-icon-search" v-model="article_title"
                    :clearable="true" title="검색" @keydown.native.enter="findArticleHandle">
                </el-input>
                <el-button type="primary" @click="findArticleHandle">
                    <i class="el-icon-search" />
                </el-button>
            </div>
        </div>
        <el-divider />
        <div style="cursor:pointer;" @click="subscribeHandle">
            <div>뉴스레터 구독신청</div>
            <div style="font-size: 13px; font-weight: 300; padding-top:10px;">춘천시 도시재생지원센터 뉴스레터를 구독신청합니다.</div>
        </div>
        <el-divider />
        <div class="wz_footer">
            <div class="row">
                <dl>
                    <dt>발행처</dt>
                    <dd>{{ publish_org }}</dd>
                </dl>
            </div>
            <div class="row">
                <dl>
                    <dt>발행인</dt>
                    <dd>{{ publisher }}</dd>
                </dl>
                <dl>
                    <dt>발행일</dt>
                    <dd>{{ publish_date }}</dd>
                </dl>
            </div>
            <div class="row">
                <dl>
                    <dt>문의</dt>
                    <dd>{{ contact }}</dd>
                </dl>
            </div>
            <div class="row">
                <dl>
                    <dt>편집위원</dt>
                    <dd>{{ editors }}</dd>
                </dl>
            </div>
        </div>
    </div>
    <!-- <div class="wz-article-toc">
        <div style="flex:1; border: 15px solid #555; width:410px;">
            <div class="wz-list-toc__con">
                <div style=" display: flex; flex-direction: column;  padding: 0 30px;flex: 1;">
                    <div style="width: 100%; text-align: center; padding: 25px 0 20px 0;">
                        <h3 style="font-weight: 400">CONTENT</h3>
                    </div>
                    <div class="category"
                         :class="webzine_category_code === 'all' ? 'selected-category' : ''">
                        <h3 @click="selectCategory('all')" class="category-title">전체</h3>
                    </div>
                    <div class="category" v-for="category in categoryList"
                         :key="category.webzine_category_code">
                        <div :class="webzine_category_code === category.webzine_category_code ? 'selected-category' : ''">
                            <h3 class="category-title"
                                @click="selectCategory(category.webzine_category_code)"
                            >{{ category.webzine_category_name }}</h3>
                        </div>
                    </div>
                    <div style="padding-top: 30px; display: flex;" >
                        <el-input placeholder="검색어를 입력하세요"
                                  prefix-icon="el-icon-search"
                                  v-model="article_title"
                                  :clearable="true"
                                  title="검색"
                                  @keydown.native.enter="findArticleHandle">
                        </el-input>
                        <el-button type="primary" @click="findArticleHandle">
                            <i class="el-icon-search"/>
                        </el-button>
                    </div>
                </div>
                <el-divider/>
                <div style="padding: 0 30px; cursor:pointer;" @click="subscribeHandle">
                    <div>뉴스레터 구독신청</div>
                    <div style="font-size: 13px; font-weight: 300; padding-top:10px;">춘천시 도시재생지원센터 뉴스레터를 구독신청합니다.</div>

                </div>
                <el-divider/>
                <div class="wz-publish-info">
                    <div class="info">
                        <span class="title">발행처 </span>
                        <span class="publish">{{ publish_org }}</span>
                    </div>
                    <div style="display: flex; justify-content: space-between">
                        <div class="info">
                            <span class="title">발행인 </span>
                            <span class="publish">{{ publisher }}</span>
                        </div>
                        <div class="info">
                            <span class="title">발행일 </span>
                            <span class="publish">{{ publish_date }}</span>
                        </div>
                    </div>
                    <div class="info">
                        <span class="title">문의 </span>
                        <span class="publish">{{ contact }}</span>
                    </div>
                    <div class="info">
                        <span class="title">편집위원 </span>
                        <span class="publish">{{ editors }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div> -->
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
    name: "WebZineListToc",
    props: ['webzine_category_code'],
    mounted() {
        window.console.log(this.webZineList)
        if (!this.webZineList || this.webZineList.length === 0) {
            this.getWebZineListHandle()
        } else {
            this.publish_org = this.webZineList[1].publish_org;
            this.publisher = this.webZineList[1].publisher;
            this.publish_date = this.webZineList[1].publish_date;
            this.contact = this.webZineList[1].contact;
            this.editors = this.webZineList[1].editors;
        }
    },
    computed: {
        ...mapGetters('webzineView', [
            'categoryList',
            'webZineList'
        ])
    },
    watch: {
        webZineList() {
            if (this.webZineList.length > 0) {
                this.publish_org = this.webZineList[1].publish_org;
                this.publisher = this.webZineList[1].publisher;
                this.publish_date = this.webZineList[1].publish_date;
                this.contact = this.webZineList[1].contact;
                this.editors = this.webZineList[1].editors;
            }
        }
    },
    data() {
        return {
            selectedCategory: 'all',
            publish_org: '',
            publisher: '',
            publish_date: '',
            contact: '',
            editors: '',
            article_title: '',
        }
    },
    methods: {
        ...mapActions('webzineView', [
            'getWebZineList',
            'getCategoryList',
            'subscribe'
        ]),

        subscribeHandle() {
            this.$prompt('이메일 주소를 입력해주세요', '', {
                confirmButtonText: '확인',
                cancelButtonText: '취소',
                inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
                inputErrorMessage: '이메일 형식이 올바르지 않습니다.'
            }).then(({ value }) => {
                const loading = this.$cmmLoading();
                this.subscribe(value)
                    .then(() => this.$successMessage('이메일을 성공적으로 등록했습니다.'))
                    .catch(() => this.$errorMessage('뉴스레터 구독 신청 중에 에러가 발생했습니다. 잠시 후 다시 시도해주세요.'))
                    .finally(() => loading.close());
            });
        },

        getWebZineListHandle() {
            return this.getWebZineList()
                .then(() => {
                    return this.getCategoryList();
                })
        },
        selectCategory(categoryCode) {
            this.$emit('selectCategory', categoryCode);
        },

        findArticleHandle() {
            this.$emit('findArticle', this.article_title);
        }
    }
}
</script>

<style scoped>
.wz-article-toc {
    display: flex;
    max-width: 480px;
}

.wz-list-toc__con {
    width: 100%;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: auto;
}

.selected-category {
    border-bottom: 1px solid #333333;
}


.category-title {
    cursor: pointer;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
}

.wz-article-toc h4 {
    margin: 10px 0;
}

.wz-article-toc h5 {
    margin: 0;
    padding: 10px 5px;
}

.article-title {
    cursor: pointer;
}

.article-title.active,
.article-title:hover {
    color: #c4953b !important;
}

.wz-publish-info {
    display: flex;
    flex-direction: column;
    padding: 25px 30px;
}

.wz-publish-info .info {
    display: flex;
    padding: 4px 0;
}

.wz-publish-info .info>span {
    display: block;
    padding: 0 3px;
}

.wz-publish-info .info>.title {
    font-weight: 300;
    font-size: 13px;
    min-width: 50px;
}

.wz-publish-info .info>.publish {
    word-break: break-all;
    white-space: pre-line;
    font-size: 12px;
}


.main-side-bar {

    display: flex;
    align-items: center;
    justify-content: center;
}


.main-side-bar>a {
    position: fixed;
    top: 0;
    left: 0;
    width: 70px;
    height: 100vh;
    color: #fff;
    writing-mode: tb-rl;
    text-align: center;
    line-height: 70px;
    font-size: 1rem;
    transition: 0.5s;
    text-decoration: none;
    background: linear-gradient(0deg, rgba(131, 58, 180, 1) 0%, rgba(253, 29, 29, 1) 50%, rgba(252, 176, 69, 1) 100%);
}

.main-side-bar>a:hover {
    text-decoration: none;
    transition: 0.5s;
    width: 70px;
    background: linear-gradient(0deg, rgba(63, 94, 251, 1) 0%, rgba(252, 70, 107, 1) 100%);
}

.main-side-bar img {
    width: 25px;
    margin-bottom: 10px;
    margin-right: 11px;
}

.main-side-bar>a>div {
    font-weight: 300;
    width: 500px;
    transform: rotate(90deg);
    text-align: center;
}

.wz_footer .row>dl+dl {
    margin-left: 0px;
}

.wz_footer {
    background-color: inherit;
}
</style>
